import { atomWithLocalStorage } from '@/context/atoms/helper/atomWithLocalStorage';
import { type Authentication } from '@ekkogmbh/apisdk';

export const authenticationAtom = atomWithLocalStorage<Authentication>('EKKO_WORKERUI_AUTH', {
  isAuthenticated: false,
});
